import React from 'react'
import {Box, Text} from '@fuegokit/react'
import {
  useRuleBuilderSteps,
  RuleBuilderStep,
  RuleBuilderSteps,
  VerticalPositionProvider
} from '../../../src/experimental/RuleBuilder'

const Content = ({index, ...rest}) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 6,
        borderRadius: 2,
        backgroundColor: 'elevation.surface.sunken'
      }}
      {...rest}
    >
      <Text>Rule builder step content for step {index + 1}</Text>
    </Box>
  )
}

const StyledRuleBuilderStepsExample = () => {
  const {activeStep, setActiveStep} = useRuleBuilderSteps({initialStep: 0})

  return (
    <>
      <VerticalPositionProvider>
        <RuleBuilderSteps activeStep={activeStep} onSelectStep={step => setActiveStep(step)}>
          <RuleBuilderStep
            condition={'when'}
            label={'Step 1'}
            index={0}
            isSelected={activeStep === 0}
            onSelect={() => setActiveStep(0)}
          >
            <Content index={0} />
          </RuleBuilderStep>
          <RuleBuilderStep
            condition={'if'}
            label={'Step 2'}
            index={1}
            isSelected={activeStep === 1}
            onSelect={() => setActiveStep(1)}
          >
            <Content index={1} />
          </RuleBuilderStep>
          <RuleBuilderStep
            condition={'then'}
            label={'Step 3'}
            index={2}
            isSelected={activeStep === 2}
            onSelect={() => setActiveStep(2)}
          >
            <Content index={2} />
          </RuleBuilderStep>
        </RuleBuilderSteps>
      </VerticalPositionProvider>
    </>
  )
}
export default StyledRuleBuilderStepsExample
